export default __webpack_public_path__ + "static/media/save.6bbac621.svg";